import { createActions, createReducer } from "reduxsauce";
import { onChangeFieldValue } from "utils/functions";
import { defaultState } from "./process-model";

export const { Types, Creators } = createActions({
  processShowLoading: [],
  processHideLoading: [],
  processShowLoadingTable: [],
  processHideLoadingTable: [],
  processEnabledRegisterButton: [],
  processDisabledRegisterButton: [],
  processShowDrawerNewProcess: [],
  processHideDrawerNewProcess: [],
  processShowDrawerEditProcess: [],
  processHideDrawerEditProcess: [],
  processUpdateFormModified: ["formEditModified"],
  processUpdateVisibleDocuments: ["visibleDocuments"],
  processFetchRegister: ["items", "totalItems"],
  processChangeFieldValue: ["fieldName", "value"],
  processDocumentsList: ["documentsList"],
  processUpdateFilter: ["filter"],
  processUpdateProcess: ["editProcess"],
  processAllProcessesList: ["allProcessesList"],
  processFetchRegisterAsync: [],
  processFetchDocumentsAsync: [],
  processSaveNewProcessAsync: ["body"],
  processDeleteByIdAsync: ["body"],
  processUpdateProcessAsync: ["body"],
  processEventInboundActive: ["eventInboundActive"],
  processEventOutboundActive: ["eventOutboundActive"],
  processImageCapturesActive: ["allowImageCapture"],
  processFetchByIdAsync: ["id"],
  processFetchAllProcessesAsync: [],
});

export const showLoading = (state = defaultState) => ({
  ...state,
  isLoading: true,
});

export const hideLoading = (state = defaultState) => ({
  ...state,
  isLoading: false,
});

export const fetchProcesses = (state, { items, totalItems }) => ({
  ...state,
  isLoading: false,
  items,
  totalItems,
});

export const changeFieldValue = (state, { fieldName, value }) => ({
  ...state,
  filter: onChangeFieldValue(state.filter, fieldName, value),
});

export const showDrawerProcess = (state = defaultState) => ({
  ...state,
  visibleDrawerNewProcess: true,
});

export const hideDrawerProcess = (state = defaultState) => ({
  ...state,
  visibleDrawerNewProcess: false,
});

export const showDrawerEditProcess = (state = defaultState) => ({
  ...state,
  visibleDrawerEditProcess: true,
});

export const hideDrawerEditProcess = (state = defaultState) => ({
  ...state,
  visibleDrawerEditProcess: false,
});

export const setDocumentsList = (state, { documentsList }) => ({
  ...state,
  ...documentsList,
});

export const updateFilter = (state, action: any) => {
  return {
    ...state,
    searchFilter: action.filter,
  };
};

export const editProcess = (state, action: any) => ({
  ...state,
  editProcess: action.editProcess,
});

export const updateformEditModified = (state, action: any) => ({
  ...state,
  formEditModified: action.formEditModified,
});

export const updateEventInboundActive = (state, action: any) => ({
  ...state,
  eventInboundActive: action.eventInboundActive,
});

export const updateEventOutboundActive = (state, action: any) => ({
  ...state,
  eventOutboundActive: action.eventOutboundActive,
});

export const updateImageCapturesActive = (state, action: any) => ({
  ...state,
  allowImageCapture: action.allowImageCapture,
});

export const updateVisibleDocuments = (state, action: any) => ({
  ...state,
  visibleDocuments: action.visibleDocuments,
});

export const setAllProcessesList = (state, { allProcessesList }) => ({
  ...state,
  ...allProcessesList,
});

export const showLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: true,
});

export const hideLoadingTable = (state = defaultState) => ({
  ...state,
  isLoadingTable: false,
});

export const disabledRegisterButton = (state = defaultState) => ({
  ...state,
  disabledButton: true,
});

export const enableRegisterButton = (state = defaultState) => ({
  ...state,
  disabledButton: false,
});

export default createReducer(defaultState, {
  [Types.PROCESS_SHOW_LOADING]: showLoading,
  [Types.PROCESS_HIDE_LOADING]: hideLoading,
  [Types.PROCESS_SHOW_LOADING_TABLE]: showLoadingTable,
  [Types.PROCESS_HIDE_LOADING_TABLE]: hideLoadingTable,
  [Types.PROCESS_DISABLED_REGISTER_BUTTON]: disabledRegisterButton,
  [Types.PROCESS_ENABLED_REGISTER_BUTTON]: enableRegisterButton,
  [Types.PROCESS_HIDE_DRAWER_NEW_PROCESS]: hideDrawerProcess,
  [Types.PROCESS_SHOW_DRAWER_NEW_PROCESS]: showDrawerProcess,
  [Types.PROCESS_HIDE_DRAWER_EDIT_PROCESS]: hideDrawerEditProcess,
  [Types.PROCESS_SHOW_DRAWER_EDIT_PROCESS]: showDrawerEditProcess,
  [Types.PROCESS_FETCH_REGISTER]: fetchProcesses,
  [Types.PROCESS_CHANGE_FIELD_VALUE]: changeFieldValue,
  [Types.PROCESS_DOCUMENTS_LIST]: setDocumentsList,
  [Types.PROCESS_UPDATE_FILTER]: updateFilter,
  [Types.PROCESS_UPDATE_PROCESS]: editProcess,
  [Types.PROCESS_UPDATE_FORM_MODIFIED]: updateformEditModified,
  [Types.PROCESS_UPDATE_VISIBLE_DOCUMENTS]: updateVisibleDocuments,
  [Types.PROCESS_EVENT_INBOUND_ACTIVE]: updateEventInboundActive,
  [Types.PROCESS_EVENT_OUTBOUND_ACTIVE]: updateEventOutboundActive,
  [Types.PROCESS_IMAGE_CAPTURES_ACTIVE]: updateImageCapturesActive,
  [Types.PROCESS_ALL_PROCESSES_LIST]: setAllProcessesList,
});
